var t = "_container_1dpe3_1",
    o = "_paginatorButton_1dpe3_7",
    n = "_moreDots_1dpe3_12",
    e = "_rotatedIconLeft_1dpe3_19",
    a = "_rotatedIconRight_1dpe3_23",
    r = {
  container: t,
  paginatorButton: o,
  moreDots: n,
  rotatedIconLeft: e,
  rotatedIconRight: a
};
export { t as container, r as default, n as moreDots, o as paginatorButton, e as rotatedIconLeft, a as rotatedIconRight };